import { gsap } from "gsap"
import { SplitText } from "gsap/SplitText";
import { getCookie, setCookie } from "../utils"

let mm = gsap.matchMedia(),
	breakPoint = 800;

export function pagePreloader() {
	mm.add(
		{
			isDesktop: `(min-width: ${breakPoint}px)`,
			isMobile: `(max-width: ${breakPoint - 1}px)`,
			reduceMotion: "(prefers-reduced-motion: reduce)",
		},
		(context) => {
			let { isDesktop } = context.conditions;

			const tl_perloader = gsap.timeline({
				paused: true,
				onComplete: () => {
					document.body.classList.remove("loading")
					document
						.querySelector(".page_preloader")
						.classList.add("hide");

				   
					setCookie("reload", "1", 1)
					localStorage.setItem("reload", 1)
				},
			})
			if (document.querySelector(".page_preloader")) {
				if (isDesktop) {
					tl_perloader.fromTo(".page_preloader__logo_svg", {
						y: 100,
						autoAlpha: 0,
					},{
						y:0,
						autoAlpha:1,
						ease: "power1.in",
						duration:0.3
					});
					tl_perloader.fromTo(".page_preloader__logo_svg #building",{
						autoAlpha:0,
						y:100,
					},{
						y:0,
						autoAlpha:1,
					    ease: "power4.inOut",
						duration:0.3
					});
					tl_perloader.fromTo(".page_preloader__logo_svg #grounds",{
						autoAlpha:0,
						y:100,
					},{
						y:0,
						autoAlpha:1,
					    ease:"slow(0.7,0.7,false)",
						duration:0.2
					});
					tl_perloader.fromTo(".page_preloader__logo_svg #southwark",{
						autoAlpha:0,
						rotation:-90,
						transformOrigin:"center bottom"
					},{
						rotation:0,
						autoAlpha:1,
						transformOrigin:"center bottom",
					    ease: "slow(0.7,0.7,false)",
						duration:0.5
					})
					tl_perloader.fromTo(".page_preloader__logo_svg #bar1",{
						autoAlpha:0,
						y:10,
					},{
						y:0,
						autoAlpha:1,
					    ease: "power1.in",
						duration:0.3
					})
					tl_perloader.fromTo(".page_preloader__logo_svg #bar2",{
						autoAlpha:0,
						y:10,
					},{
						y:0,
						autoAlpha:1,
					    ease: "power1.in",
						duration:0.3
					},"-=0.3");
					const southwarkLogo = document.querySelector('.logo_southwark');
					const targetLogo  = document.querySelector('.page_preloader__logo');

					const southwarkLogoRect = southwarkLogo.getBoundingClientRect();
					const targetLogoRect = targetLogo.getBoundingClientRect();
					const targetY = targetLogoRect.top  - window.pageYOffset;
					const sourceY = southwarkLogoRect.top  - window.pageYOffset;

					const moveY =(targetY - sourceY) * -1;

					tl_perloader.to(".page_preloader__logo",{y: moveY,ease: "power2.out", duration:1})
					tl_perloader.to(".page_preloader__overlay",{y: "-100%", opacity:0, ease: "power2.out", duration:1 })
					tl_perloader.to(".page_preloader__logo",{autoAlpha:0});


					// tl_perloader.fromTo(mainHeadingsplit.words,{
					// 	y:100,
					// },{
					// 	y:0,
					// 	duration: 0.7, 
					// 	ease: "back",
					// 	stagger:0.15
					// })
					// tl_perloader.to(".page_preloader__logo", {
					// 	y: -100,
					// 	opacity: 0,
					// 	ease: "ease.inOut",
					// 	duration: 0.8,
					// 	delay: 0.4,	
					// })

					// tl_perloader.to(".app_header__top_bar_border", {
					// 	width: "100%",
					// 	ease: "ease",
					// 	duration: 0.8,
					// })
					// tl_perloader.to(
					// 	".app_header__top_bar_items .app_header__top_bar_item",
					// 	{
					// 		y: 0,
					// 		opacity: 1,
					// 		zIndex: 200,
					// 		ease: "ease.inOut",
					// 		duration: 0.5,
					// 		stagger: 0.05,
					// 	},
					// 	"-=0.5"
					// )
					// tl_perloader.to(".app__header_logos svg", {
					// 	y: 0,
					// 	opacity: 1,
					// 	zIndex: 200,
					// 	ease: "ease.inOut",
					// 	duration: 0.5,
					// 	stagger: 0.05,
					// })
					// tl_perloader.to(
					// 	".app_header__nav__links .app_header__nav__link",
					// 	{
					// 		y: 0,
					// 		opacity: 1,
					// 		zIndex: 200,
					// 		ease: "ease.inOut",
					// 		duration: 0.8,
					// 		stagger: 0.05,
					// 	}
					// )
					// tl_perloader.to(".page_preloader", {
					// 	opacity: 0,
					// 	delay: 0.5,
					// 	duration: 0.8,
					// 	zIndex: -1,
					// 	ease: "ease.inOut",
					// })
				}
			}
			const reloadCookie = getCookie("reload");

			if (!reloadCookie) {
				localStorage.clear("reload")
			}
			const reload = localStorage.getItem("reload")
			if (!reload) {
				tl_perloader.play()
			} else {
				document.body.classList.remove("loading")
				document.querySelector(".page_preloader").classList.add("hide")
			}


		

			// Heading
			const headings = document.querySelectorAll('.custom_heading_anim');
			headings.forEach(el=>{
				// word split
				let split = SplitText.create(el,{
					mask:'words'
				});
				gsap.from(split.words,{
					y:100,
					duration: 0.7, 
                    ease: "back",
					stagger:0.15
				})
			})
		}
	)
}


if(document.querySelector('.page_preloader')){
	window.addEventListener("load", pagePreloader)
}
